module.exports = __webpack_public_path__ + "img/sprite.a283d7e3.png";